/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;
module.exports = reInterpolate;